module.exports = __webpack_public_path__ + "img/灯装配体.SLDASM.5a1070c7.jpg";